import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR, ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'ui-atom-checkbox',
  standalone: true,
  imports: [
    ReactiveFormsModule
  ],
  templateUrl: './ui-atom-checkbox.component.html',
  styleUrl: './ui-atom-checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiAtomCheckboxComponent),
      multi: true,
    },
  ]

})
export class UiAtomCheckboxComponent {

  @Input() textId: string = '';
  @Input() labelText: string = ''; // Texto de la etiqueta
  @Input() isRequired: boolean = false; // Si el checkbox es requerido
  @Output() changeEvent = new EventEmitter<boolean>(); // Evento para (change)

  isChecked: boolean = false; // Estado interno del checkbox
  private onChange: (value: boolean) => void = () => {
  };
  private onTouched: () => void = () => {
  };

  // Metodo llamado cuando el estado del checkbox cambia
  onCheckboxChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.isChecked = inputElement.checked;
    this.onChange(this.isChecked); // Notifica el cambio al formulario
    this.changeEvent.emit(this.isChecked); // Emitir el evento opcional
    this.onTouched(); // Marca como tocado
  }

  // Metodos requeridos por ControlValueAccessor

  // Escribe el valor inicial o externo al control
  writeValue(value: boolean): void {
    this.isChecked = value;
  }

  // Registra el metodo a llamar cuando el valor cambia
  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  // Registra el metodo a llamar cuando el control es "tocado"
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
